import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FormattedMessage } from 'react-intl';
import style from '../dropdown-style.module.less';
import sharedStyle from '../shared.module.less';

const getSelectedService = (pickupServices, selectedPickupServiceCode) => {
  if (selectedPickupServiceCode && pickupServices) {
    return pickupServices.find(({ code }) => code === selectedPickupServiceCode);
  }

  return null;
};

export const PickupServiceDropdown = ({
  selectedPickupServiceCode = null,
  onPickupServiceSelected,
  pickupServices,
  className = null,
  required = false,
  hasError = false,
}) => {
  const buildDropdown = (pickupService) => (
    <DropdownMenuItem
      key={pickupService.code}
      onClick={() => onPickupServiceSelected(pickupService)}
      selected={pickupService.code === selectedPickupServiceCode}
    >
      <div className={style.title}>{pickupService.name}</div>
      <div className={style.subtitle}>{pickupService.description}</div>
    </DropdownMenuItem>
  );

  const defaultDropdownTitle = (
    <FormattedMessage defaultMessage='Select service...' description='pickupService.selectService' id='u5UiT5' />
  );

  const selectedService = getSelectedService(pickupServices, selectedPickupServiceCode);

  const pickupServiceTitle = selectedService ? selectedService.name : defaultDropdownTitle;

  return (
    <React.Fragment>
      <div className={sharedStyle.row}>
        <div className={sharedStyle.label}>
          <FormattedMessage defaultMessage='Pickup Service' description='pickupService.pickupService' id='ZitpTU' />
        </div>
        <div className={sharedStyle.value}>
          <DropdownMenu className={className}>
            <DropdownMenuToggler hasError={hasError} required={required}>
              {pickupServiceTitle}
            </DropdownMenuToggler>
            {pickupServices.map(buildDropdown)}
          </DropdownMenu>
        </div>
      </div>
    </React.Fragment>
  );
};

PickupServiceDropdown.propTypes = {
  pickupServices: PropTypes.array.isRequired,
  className: PropTypes.string,
  required: PropTypes.bool,
  selectedPickupServiceCode: PropTypes.string,
  hasError: PropTypes.bool,
  onPickupServiceSelected: PropTypes.func.isRequired,
};
